'use strict';

$(document).ready(function () {
    $('.ui.sidebar')
        .sidebar({context: $('.ui.pushable')})
        .sidebar('attach events', '#mobile_item');

    $('#contact-btn, .contact-us').on('click', function(){
	    $('.ui.modal.contact').modal('show');
    });
    $('.ui.modal').modal({
        closable: true
    });

    $('.ui.accordion')
        .accordion({
            exclusive: false,
            duration: 100
        });
});

var externalVideos = externalVideos || {};
function activateExternalVideos(){
    localStorage && localStorage.setItem('externalVideosActivated', 1);
    for (var videoId in externalVideos) {
        if (externalVideos.hasOwnProperty(videoId)) {
            var video = $('#video_'+videoId);
            if(video.length>0 && externalVideos[videoId]){
                video.find('.dsgvoOverlay').hide();
                video.find('.deactivate').show();
                if(!video.find('iframe').attr('src')){
                    video.find('iframe').attr('src',externalVideos[videoId]);
                }
            }
        }
    }
}

function deactivateExternalVideos(){
    localStorage && localStorage.setItem('externalVideosActivated', 0);
    for (var videoId in externalVideos) {
        if (externalVideos.hasOwnProperty(videoId)) {
            var video = $('#video_'+videoId);
            if(video.length>0 && externalVideos[videoId]){
                video.find('.dsgvoOverlay').show();
                video.find('.deactivate').hide();
                video.find('iframe').attr('src','');

            }
        }
    }
}

function checkExternalVideos(){
    if(localStorage){
        if(localStorage.getItem('externalVideosActivated')==="1"){
            activateExternalVideos();
        }
    }
}

setTimeout(checkExternalVideos, 1);

